import { useEffect, useRef } from 'react';
import { ONB_CSS, ONB_HTML, initOnboarding } from './onboardingSource';
import { LEGACY_LIGHT_THEME } from '../legacyLightTheme';
import { enhanceLegacyInteractions } from '../enhanceLegacyInteractions';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';
import { createRoot } from 'react-dom/client';
import { MultiSelect } from '../../components/ui/multi-select';
import { SingleSelect } from '../../components/ui/single-select';
import { buildAuthHeaders } from '../../utils/api';
import { BACKEND_BASE_URL, BACKEND_DIRECT_ACCESS_CODE } from '../../config/backendConfig';

// Native React onboarding funnel dashboard (PR3 — replaces the former iframe).
// The original standalone app's CSS + markup + logic run verbatim inside a
// Shadow DOM. It hits the live KPI dashboard API using the fixed backend
// config (src/config/backendConfig.js); if that isn't configured yet it
// falls back to the 3 JSON files in public/onboarding/.
function getApiConfig() {
  if (!BACKEND_BASE_URL) return null;
  const headers = buildAuthHeaders({ directAccessCode: BACKEND_DIRECT_ACCESS_CODE });
  return headers ? { baseUrl: BACKEND_BASE_URL, headers } : null;
}

export default function OnboardingDashboard() {
  const hostRef = useRef(null);
  const { resolvedTheme } = useTheme();
  const { currentUser } = useAuth();

  useEffect(() => {
    const host = hostRef.current;
    if (!host) return;
    const root = host.shadowRoot || host.attachShadow({ mode: 'open' });
    root.innerHTML = `<style>${ONB_CSS}\n${LEGACY_LIGHT_THEME}</style>` + ONB_HTML;
    const kamMount = root.getElementById('kamFilterMount');
    const kamRoot = createRoot(kamMount);
    let platformRoot = null;
    window.renderOnboardingKamFilter = ({ options, selected, onChange }) => kamRoot.render(
      <MultiSelect label="KAM filter" options={options} selected={selected} onChange={onChange} allLabel="All KAMs" />
    );
    window.renderOnboardingPlatformFilter = ({ options, value, onChange }) => {
      platformRoot?.unmount();
      const mount = root.getElementById('platformFilterMount');
      if (!mount) return;
      platformRoot = createRoot(mount);
      platformRoot.render(<SingleSelect label="Platform filter" options={options} value={value} onChange={onChange} allLabel="All platforms" />);
    };
    const cleanupInteractions = enhanceLegacyInteractions(root);
    const cleanupOnboarding = initOnboarding(root, getApiConfig(), currentUser?.kamFullName || null);
    return () => {
      cleanupOnboarding(); cleanupInteractions();
      if (window.renderOnboardingKamFilter) delete window.renderOnboardingKamFilter;
      if (window.renderOnboardingPlatformFilter) delete window.renderOnboardingPlatformFilter;
      platformRoot?.unmount(); kamRoot.unmount(); root.innerHTML = '';
    };
  }, []);

  return <div className="onboarding-host" data-theme={resolvedTheme} ref={hostRef} />;
}
